import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-menu-accordion',
  template: `<ng-content></ng-content>`,
  styleUrls: ['./menu-accordion.component.scss']
})

export class MenuAccordionComponent {
  @Input()
  closeOthers = true;

  @Input()
  showArrows = false;

  @Input()
  expandAll = false;
}
